// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // apiBaseUrl: 'https://v2backend.quidak.com/api',
  // apiBaseUrlUpload: 'https://v2backend.quidak.com/',
  
  //apiBaseUrl: 'http://localhost:8000/api',
  //apiBaseUrlUpload: 'http://localhost:8000/',
  //apiPosBaseUrl: 'http://localhost:57571/'

  // apiBaseUrl: 'https://backend.astmotoparts.com/api',
  // apiPosBaseUrl: 'https://backend.astmotoparts.com/api',
  // apiBaseUrlUpload: 'https://backend.astmotoparts.com/',
  
  apiBaseUrl: 'https://savback.quidak.com/api',
  apiBaseUrlUpload: 'https://savback.quidak.com/',
  apiPosBaseUrl: 'http://savback.quidak.com/api'
  
  // apiBaseUrl: 'http://api.quidak.local/api',
  // apiBaseUrlUpload: 'http://api.quidak.local/',

  // apiBaseUrl: 'http://192.168.10.51:8000/api',
  // apiBaseUrlUpload: 'http://192.168.10.51:8000/',

  // apiBaseUrl: 'https://back.quidak.com/api',
  // apiBaseUrlUpload: 'https://back.quidak.com/',

  // apiPosBaseUrl: 'http://pos.quidak.com/'

  // apiBaseUrl: 'https://bakocam.servererp.cloud/api',
  // apiBaseUrlUpload: 'https://bakocam.servererp.cloud/',
  // apiPosBaseUrl: 'https://pos.servererp.cloud/'

   // apiBaseUrl: 'https://ca.quidak.com/api',
   // apiBaseUrlUpload: 'https://ca.quidak.com/'

  // apiBaseUrl: 'https://back.bertinosoft.com/api',
  // apiBaseUrlUpload: 'https://back.bertinosoft.com/'

  // apiBaseUrl: 'https://back.anucamsoft.com/api',
  // apiBaseUrlUpload: 'https://back.anucamsoft.com/'

  // apiBaseUrl: 'https://back.nkapadistribution.com/api',
  // apiBaseUrlUpload: 'https://back.nkapadistribution.com/'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
